import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {PublicNavigationComponent} from "../public-navigation/public-navigation.component";
import {PublicFooterComponent} from "../footer/footer.component";

@Component({
    selector: 'app-landing',
    imports: [CommonModule, RouterModule, PublicNavigationComponent, PublicFooterComponent],
    templateUrl: './landing.component.html',
    styleUrl: './landing.component.scss'
})
export class LandingComponent implements OnInit {

    ngOnInit(): void {}
}
